@use "../../../node_modules/@thelabnyc/breakpoint-sass/stylesheets/breakpoint";
@use "../../styles/layout";

.root {
    background: radial-gradient(
        ellipse at 50% 90%,
        var(--color-monza) 80%,
        var(--color-tamarillo) 140%
    );
    height: 80vh;
    overflow: hidden;
    padding: 3rem 0 2rem;
    position: relative;
    text-align: center;

    &::before {
        background: radial-gradient(
            ellipse at 50% 10%,
            rgb(0 0 0 / 0%) 0%,
            rgb(0 0 0 / 0%) 38%,
            rgb(143 40 36 / 100%)
        );
        content: "";
        height: 100%;
        inset: 0;
        pointer-events: none;
        position: absolute;
        width: 100%;
        z-index: 100;

        @include breakpoint.breakpoint(layout.$belowMedium) {
            opacity: 0.6;
        }
    }

    &::after {
        background: linear-gradient(
            to bottom,
            transparent 0%,
            transparent 93%,
            var(--color-monza) 98%,
            var(--color-monza) 100%
        );
        content: "";
        position: absolute;
        inset: 0;
        z-index: 10;
        pointer-events: none;
    }
}

.content {
    display: flex;
    flex-direction: column;
    margin: 0 auto;
    width: fit-content;
}

.timer {
    align-items: center;
    color: var(--color-white);
    display: flex;
    justify-content: center;
    gap: 1rem;
    font-family: "Alt Gothic Compressed", sans-serif;
}

.segment {
    display: flex;
    flex-direction: column;
    align-items: center;
}

.number {
    font-size: 15vw;
    font-weight: 700;
    line-height: 1;
    margin-bottom: -11vw;

    @include breakpoint.breakpoint(layout.$belowMedium) {
        font-size: 24vw;
        margin-bottom: -17vw;
    }
}

.label {
    font-size: 3vw;
    text-transform: uppercase;
    margin-bottom: 2.5vw;
    z-index: 1;

    @include breakpoint.breakpoint(layout.$belowMedium) {
        font-size: 5vw;
    }
}
